/**
 * Extracts a descriptive error message from a failed fetch call.
 * - For HTTP errors (res.ok === false): reads the response body to get the server message.
 * - For network errors (catch block): distinguishes offline vs. server unreachable vs. CORS.
 */

export async function getResponseError(res) {
  const clientErrorMessages = {
    400: "Petición incorrecta",
    401: "No autorizado — sesión expirada o inválida",
    403: "Sin permisos para realizar esta acción",
    404: "Recurso no encontrado",
    413: "El cuerpo de la petición es demasiado grande (imagen demasiado grande)",
    422: "Datos inválidos",
  };

  // 5xx: no leer el cuerpo — puede contener info interna sensible
  if (res.status >= 500) {
    const serverErrorMessages = {
      500: "Error interno del servidor. Contacta con el administrador.",
      502: "El servidor no está disponible. Inténtalo de nuevo más tarde.",
      503: "Servicio no disponible. Inténtalo de nuevo más tarde.",
    };
    return serverErrorMessages[res.status] ?? `Error del servidor (${res.status}). Contacta con el administrador.`;
  }

  // 4xx: el cuerpo es un mensaje de validación/negocio, seguro de mostrar
  let message = `Error ${res.status}`;
  if (clientErrorMessages[res.status]) message += ` — ${clientErrorMessages[res.status]}`;

  try {
    const body = await res.json();
    const detail = body?.err || body?.message || body?.error;
    if (detail) message += `: ${detail}`;
  } catch (_) {}

  return message;
}

export function getNetworkError(err) {
  if (!navigator.onLine) return "Sin conexión a internet.";
  if (err?.message === "Failed to fetch")
    return "No se pudo conectar con el servidor. Comprueba que la API está activa y que no hay un problema de CORS.";
  return err?.message || "Error de red desconocido.";
}
